import { apiRequest, IFetchQuery, IResponse } from '@services/base';

import { ICarrierLog } from './carrierLog.model';

const apiPrefix = process.env.REACT_APP_API_PATH_PREFIX;

export const getCarrierLogs = async (query: IFetchQuery) => {
  const queryString = new URLSearchParams(
    Object.entries(query).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = String(value);
      }
      return acc;
    }, {} as Record<string, string>),
  ).toString();

  return apiRequest.get<IResponse & { logs: ICarrierLog[] }>(
    `${apiPrefix}/carrier-logs?${queryString}`,
  );
};

export const getCarrierLog = async (logId: string) => {
  return apiRequest.get<IResponse & { log: ICarrierLog }>(
    `${apiPrefix}/carrier-logs/${logId}`,
  );
};
